import styled from 'styled-components'

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`

export const Content = styled.div`
  position: relative;
  margin-top: 75px;
  flex: 1;
  padding-top: 20px;
  position: relative;

  display: flex;
  flex-direction: column;
`

export const Title = styled.h1`
  font-size: 30px;
  margin: 0;
  padding: 0;
`

export const Group = styled.div`
  display: flex;
  align-items: center;
  height: 38px;
`

export const CardInfo = styled.div`
  width: auto;
  min-width: 45.95px;
  height: 30px;
  border-radius: 5px;

  display: flex;
  align-items: center;
  justify-content: center;
  background: #1b77fd;

  p {
    all: unset;
    font-size: 12px;
    color: white;
    font-weight: bold;
  }
`

export const CardSituation = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 5px;

  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ color }) => color};
  color: white;
  font-weight: bold;
`

export const PickingCard = styled.div`
  width: 100%;
  height: 100px;

  margin-top: 20px;
  padding: 5px;
  border-radius: 10px;
  background: rgb(224, 224, 224);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Buttons = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  padding: 10px 0;
`
